
import React from 'react';
import Layout from '@/components/Layout/Layout';
import ChurchSteepleHero from '@/components/ChurchSteeple/ChurchSteepleHero';
import ChurchSteepleIntroduction from '@/components/ChurchSteeple/ChurchSteepleIntroduction';
import ChurchSteepleServices from '@/components/ChurchSteeple/ChurchSteepleServices';
import ChurchSteepleProcess from '@/components/ChurchSteeple/ChurchSteepleProcess';
import ChurchSteepleCommonIssues from '@/components/ChurchSteeple/ChurchSteepleCommonIssues';
import ChurchSteepleFAQ from '@/components/ChurchSteeple/ChurchSteepleFAQ';

const ChurchSteepleRepair = () => {
  return (
    <Layout>
      <div className="w-full">
        <ChurchSteepleHero />
        <ChurchSteepleIntroduction />
        <ChurchSteepleServices />
        <ChurchSteepleProcess />
        <ChurchSteepleCommonIssues />
        <ChurchSteepleFAQ />
      </div>
    </Layout>
  );
};

export default ChurchSteepleRepair;
